export default __webpack_public_path__ + "static/media/logo-white.f3a44bac.png";